import { render } from "./slide6.vue?vue&type=template&id=f61bd2f6&scoped=true"
import script from "./slide6.vue?vue&type=script&lang=js"
export * from "./slide6.vue?vue&type=script&lang=js"

import "./slide6.vue?vue&type=style&index=0&id=f61bd2f6&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f61bd2f6"]])

export default __exports__